import React, { useState, useEffect, useRef } from "react";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import moment from "moment";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";

const EditAssetForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Asset"));
  }, []);
  const initialFormData = {
    ID: "",
    Name: "",
    Description: "",
    ItemType_001: null,
    Brand_1158: null,
    Model_1159: null,
    CategoryID_1160: null,
    IsDiscontinued: null,
    IsVariantRequired: null,
    InvoiceNumber: null,
    AssetType: null,
    Allocated: null,
    PurchaseDate: "",
    VendorID: null,
    BatchNo: "",
    WarrantyDate: "",
    AssetPrice: "",
    PaymentMethod: "",
    PaymentDate: null,
    TransactionNo: "",
    SubscriptionStartDate: "",
    SubscriptionEndDate: "",
    Storage: "",
    Memory: "",
    Processor: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assetTypeOption, setAssetTypeOption] = useState([]);
  const [allocatedOption, setAllocatedOption] = useState([]);
  const [categoryTypeOption, setCategoryTypeOption] = useState([]);
  const [brandOption, setBrandOption] = useState([]);
  const [modelOption, setModelOption] = useState([]);
  const [vendorOption, SetVendorOption] = useState([]);
  const [invoiceNumberOption, SetInvoiceNumberOption] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [statusOption, setStatusOPton] = useState([]);
  const [assetname, setAssetName] = useState("");
  const [paymentOption, setPaymentMoethodOption] = useState([]);

  useEffect(() => {
    fetchGetAddAsset();
    if (id) {
      fetchGetAddAssetShow(id);
    }
  }, []);

  const fetchGetAddAsset = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}asset?P_AssetType=0&P_CategoryID_1160=0&P_Allocated=0&P_AssetID=0`
      );
      if (response.status === 200) {
        setPageLoading(false);
        const cleanedData = response?.data;


        const assetList = Object.entries(response?.data?.assetType || {}).map(
          ([key, value]) => ({
            value: parseInt(key, 10), // Convert key to a number
            label: value,
          })
        );

        setAssetTypeOption(assetList);

        const payMeth = Object.entries(response?.data?.paymentMethod || {}).map(
          ([key, value]) => ({
            value: key, // Convert key to a number
            label: value,
          })
        );

        setPaymentMoethodOption(payMeth);
        const allocated = Object.entries(
          response?.data?.allocatedType || {}
        ).map(([key, value]) => ({
          value: parseInt(key, 10), // Convert key to a number
          label: value,
        }));

        setAllocatedOption(allocated);

        const vendorList = response?.data?.vendorList?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        SetVendorOption(vendorList);
        const invoiceList = response?.data?.invoiceList?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        SetInvoiceNumberOption(invoiceList);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };
  const fetchGetAddAssetShow = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}asset/${id}`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;

        const categoryList = response?.data?.category?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Name,
        }));
        setCategoryTypeOption(categoryList);
        const brandListopt = response?.data?.brands?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Brand,
        }));
        setBrandOption(brandListopt);
        const modelListOpt = response?.data?.models?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Model,
        }));
        setModelOption(modelListOpt);
        const formDataEdit = {
          Name: cleanedData?.Name,
          ID: cleanedData?.ID,
          Description: cleanedData?.Description,
          ItemType_001: cleanedData?.ItemType_001,
          Brand_1158: cleanedData?.Brand_1158,
          Model_1159: cleanedData?.Model_1159,
          InvoiceNumber: cleanedData?.InvoiceNumber,
          CategoryID_1160: cleanedData?.CategoryID_1160,
          IsDiscontinued: cleanedData?.IsDiscontinued,
          IsVariantRequired: cleanedData?.IsVariantRequired,
          AssetType: cleanedData?.AssetType
            ? Number(cleanedData?.AssetType)
            : 0,
          Allocated: cleanedData?.Allocated,
          PurchaseDate: cleanedData?.PurchaseDate,
          VendorID: cleanedData?.VendorID,
          BatchNo: cleanedData?.BatchNo,
          WarrantyDate:
            (cleanedData?.WarrantyDate &&
              moment(cleanedData?.WarrantyDate).format("DD-MMM-YYYY")) ||
            "",
          AssetPrice: cleanedData?.AssetPrice,
          PaymentMethod: cleanedData?.PaymentMethod,
          PaymentDate:
            cleanedData?.PaymentDate !== null
              ? moment(cleanedData?.PaymentDate).format("DD-MMM-YYYY")
              : "",
          TransactionNo: cleanedData?.TransactionNo,
          Storage: cleanedData?.Storage,
          Memory: cleanedData?.Memory,
          Processor: cleanedData?.Processor,
          SubscriptionStartDate: cleanedData?.SubscriptionStartDate
            ? moment(cleanedData?.SubscriptionStartDate).format("DD-MMM-YYYY")
            : "",
          SubscriptionEndDate: cleanedData?.SubscriptionEndDate
            ? moment(cleanedData?.SubscriptionEndDate).format("DD-MMM-YYYY")
            : "",
        };

        setFormData(formDataEdit);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

    const fetchGetModelDetails = async (id) => {
      try {
        const queryParams = new URLSearchParams({
          BrandID: id,
        });
        const response = await GetServiceCaller(
          `${API_URL}get-models?${queryParams.toString()}`
        );
        if (response.status === 200) {
          const fetchData = response?.data?.data;
          const data = response?.data;
          // Safely access the AssetCode from the first item in the getCategory array
          const code = data?.getCategory?.[0]?.AssetCode ?? null; // Use nullish coalescing for a fallback value
          // setAssetName(code)
          // console.log("AssetCode:", code);
          const modelList = fetchData?.map((ele, index) => ({
            value: ele?.ID,
            label: ele?.Model,
          }));
  
          setModelOption(modelList);
  
          setLoading(false);
        } else {
          console.error(
            "Failed to fetch model masters. Server responded with status:",
            response.status
          );
        }
      } catch (error) {
        console.error("An error occurred while fetching brand details:", error);
      }
    };

  const schema = Yup.object().shape({
    AssetPrice: Yup.string().required("Price is Required"),
    Model_1159: Yup.number().nullable(),
    CategoryID_1160: Yup.number().required("Category is Required"),
    Brand_1158: Yup.number().nullable(),
    AssetType: Yup.number().required("Asset Type is Required"),
    Allocated: Yup.string().required("Status is Required"),
    PurchaseDate: Yup.string().required("Purchase Date is Required"),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Optionally, show error using toast
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };

  const handleSelect = async (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  const handleInvoiceSelect = async (selectedOption, name) => {

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.label };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => {
      const updatedData = { ...prevState, [name]: value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     setLoading(true);
  //     console.log("Submitting Form Data:", formData);

  //     try {
  //       // Validate the entire form, capturing all errors
  //       await schema.validate(formData, { abortEarly: false });

  //       // If validation passes, clear errors
  //       setErrors({});
  //       const response = await PostServiceCaller(
  //         `${API_URL}asset/${id}`,
  //         formData,
  //         "put"
  //       );

  //       if (response.status === 200) {
  //         toast.success("Data submitted successfully");
  //         // Redirect after a successful submission
  //         setTimeout(() => {
  //           navigate(`/add-asset`);
  //         }, 2000);
  //       } else {
  //         console.error(
  //           "Failed to submit data. Server responded with status:",
  //           response.status
  //         );
  //       }
  //     } catch (error) {
  //       // Handle validation errors
  //       if (error.inner) {
  //         const errors = {};
  //         error.inner.forEach((err) => {
  //           errors[err.path] = err.message;
  //         });
  //         setErrors(errors);
  //       } else {
  //         console.error("Unexpected Error:", error);
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate the entire form, capturing all errors
      await schema.validate(formData, { abortEarly: false });

      // If validation passes, clear errors
      setErrors({});

      // Prepare payload based on AssetType selection
      let additionalFields = {};
      if (formData.AssetType === 1) {
        // AssetType "1" (Software) - Include Subscription Dates
        additionalFields = {
          SubscriptionStartDate:
            formData?.SubscriptionStartDate &&
            moment(formData?.SubscriptionStartDate).format("YYYY-MM-DD"),
          SubscriptionEndDate:
            formData?.SubscriptionEndDate &&
            moment(formData?.SubscriptionEndDate).format("YYYY-MM-DD"),
        };
      } else if (formData.AssetType === 0) {
        // AssetType "0" (Hardware) - Include Storage, Memory, and Processor
        additionalFields = {
          Storage: formData?.Storage || "",
          Memory: formData?.Memory || "",
          Processor: formData?.Processor || "",
        };
      }

      // Proceed with API call
      const response = await PostServiceCaller(
        `${API_URL}asset/${formData.ID}`,
        {
          ...formData,
          ...additionalFields, // Include extra fields based on AssetType
          PurchaseDate:
            (formData?.PurchaseDate &&
              moment(formData?.PurchaseDate).format("YYYY-MM-DD")) ||
            "",
          WarrantyDate:
            (formData?.WarrantyDate &&
              moment(formData?.WarrantyDate).format("YYYY-MM-DD")) ||
            "",
        },
        "put"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          navigate(`/add-asset`);
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      // Handle form validation errors
      if (error instanceof Yup.ValidationError) {
        // Update error state for all fields with validation errors
        const errorMessages = error.inner.reduce((acc, curr) => {
          acc[curr.path] = curr.message;
          return acc;
        }, {});

        // Set the error state
        setErrors(errorMessages);

        console.error("Validation errors:", errorMessages);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
           <div className="Container">
              <form
                id="formOne"
                className="rounded mt-2 bg-white"
                onSubmit={handleSubmit}
              >
                <div class="card-body  mx-2">
                  <div className="row">
                    <div className="col-md-3">
                      <label class="form-label">
                        Asset Type<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="AssetType"
                        onChange={(selectedOption, action) => (
                          handleSelect(selectedOption, action.name),
                          setFormData((prevData) => ({
                            ...prevData,
                            CategoryID_1160: null,
                            Brand_1158: null,
                            Model_1159: null,
                          }))
                        )}
                        value={assetTypeOption?.find(
                          (o) => o.value === Number(formData?.AssetType)
                        )}
                        className={` ${errors.AssetType ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...assetTypeOption,
                        ]}
                      />
                      {errors.AssetType && (
                        <div className="invalid-feedback">
                          {errors.AssetType}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="CategoryID_1160"
                        onChange={(selectedOption, action) => (
                          handleSelect(selectedOption, action.name),
                          setFormData((prevData) => ({
                            ...prevData,
                            Brand_1158: null,
                            Model_1159: null,
                          }))
                        )}
                        value={
                          formData.CategoryID_1160 == null
                            ? ""
                            : categoryTypeOption.find(
                                (o) => o.value == formData.CategoryID_1160
                              ) || null
                        }
                        className={` ${
                          errors.CategoryID_1160 ? "is-invalid" : ""
                        }`}
                        options={[
                          { value: null, label: "Select" },
                          ...categoryTypeOption,
                        ]}
                      />
                      {errors.CategoryID_1160 && (
                        <div className="invalid-feedback">
                          {errors.CategoryID_1160}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Asset Name</label>
                      <input
                        type="text"
                        value={formData?.Name}
                        disabled
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Make</label>
                      <Select
  name="Brand_1158"
  onChange={(selectedOption, action) => {
    // Handle the select change
    handleSelect(selectedOption, action.name);
    
    // Reset the model field when brand changes
    setFormData((prevData) => ({
      ...prevData,
      Model_1159: null,
    }));
    
    // Call the API with the selected brand ID if a brand is selected
    if (selectedOption && selectedOption.value !== null) {
      fetchGetModelDetails(selectedOption.value);
    }
  }}
  value={
    formData.Brand_1158 == null
      ? ""
      : brandOption.find((o) => o.value == formData.Brand_1158) || null
  }
  className={` ${errors.Brand_1158 ? "is-invalid" : ""}`}
  options={[
    { value: null, label: "Select" },
    ...brandOption,
  ]}
/>
                      {errors.Brand_1158 && (
                        <div className="invalid-feedback">
                          {errors.Brand_1158}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">Model</label>
                      <Select
                        name="Model_1159"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={
                          modelOption?.find(
                            (o) => o.value === formData?.Model_1159
                          ) || null
                        }
                        className={` ${errors.Model_1159 ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...modelOption,
                        ]}
                      />
                      {errors.Model_1159 && (
                        <div className="invalid-feedback">
                          {errors.Model_1159}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Purchase Date<span className="text-danger">*</span>
                      </label>
                      <CustomDatePicker
                        // handleChange={(e) => handleReqDate(e)}
                        handleChange={(e) => handleChange(e)}
                        value={
                          formData.PurchaseDate
                            ? moment(formData.PurchaseDate).format(
                                "DD-MMM-YYYY"
                              )
                            : ""
                        }
                        name="PurchaseDate"
                        className={`form-control ${
                          errors.PurchaseDate ? "is-invalid" : ""
                        }`}
                        placeholderText="DD-MM-YYYY"
                      />
                      {errors.PurchaseDate && (
                        <div className="text-danger">{errors.PurchaseDate}</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Vendor</label>
                      <Select
                        name="VendorID"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={vendorOption?.find(
                          (o) => o.value == formData?.VendorID
                        )}
                        className={` ${errors.VendorID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...vendorOption,
                        ]}
                      />
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Invoice No.</label>

                      <Select
                        name="InvoiceNumber"
                        onChange={(selectedOption, action) =>
                          handleInvoiceSelect(selectedOption, action.name)
                        }
                        value={invoiceNumberOption?.find(
                          (o) => o.label === formData?.InvoiceNumber
                        )}
                        className={` ${
                          errors.InvoiceNumber ? "is-invalid" : ""
                        }`}
                        options={[
                          { value: null, label: "Select" },
                          ...invoiceNumberOption,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label className="form-label">
                        Price<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text "
                        name="AssetPrice"
                        value={formData?.AssetPrice}
                        className={` form-control ${
                          errors.AssetPrice ? "is-invalid" : ""
                        }`}
                        onChange={(e) => handleChange(e)}
                      />
                      {errors.AssetPrice && (
                        <div className="invalid-feedback">
                          {errors.AssetPrice}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Service Tag No#</label>
                      <input
                        type="text "
                        name="BatchNo"
                        className="form-control"
                        value={formData?.BatchNo}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">
                        Status<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Allocated"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={allocatedOption?.find(
                          (o) => o.value === formData?.Allocated
                        )}
                        options={[
                          { value: null, label: "Select" },
                          ...allocatedOption,
                        ]}
                        className={` ${errors.Allocated ? "is-invalid" : ""}`}
                      />
                      {errors.Allocated && (
                        <div className="invalid-feedback">
                          {errors.Allocated}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Description</label>
                      <textarea
                        name="Description"
                        value={formData?.Description}
                        onChange={(e) => handleChange(e)}
                        className={`form-control`}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    {formData?.AssetType === 0 && (
                      <div className="col-md-3">
                        <label className="form-label">Warranty Date</label>
                        <CustomDatePicker
                          // handleChange={(e) => handleReqDate(e)}
                          handleChange={(e) => handleChange(e)}
                          value={formData.WarrantyDate}
                          name="WarrantyDate"
                          className="form-control"
                          placeholderText="DD-MM-YYYY"
                        />
                      </div>
                    )}
                    {formData?.AssetType === 1 && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">
                            Subscription Start Date
                          </label>
                          <CustomDatePicker
                            // handleChange={(e) => handleReqDate(e)}
                            handleChange={(e) => handleChange(e)}
                            value={formData.SubscriptionStartDate}
                            name="SubscriptionStartDate"
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            Subscription End Date
                          </label>
                          <CustomDatePicker
                            // handleChange={(e) => handleReqDate(e)}
                            handleChange={(e) => handleChange(e)}
                            value={formData.SubscriptionEndDate}
                            name="SubscriptionEndDate"
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                          />
                        </div>
                      </>
                    )}
                    {formData?.AssetType === 0 && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">Storage</label>
                          <input
                            type="text"
                            name="Storage"
                            value={formData?.Storage}
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Memory</label>
                          <input
                            type="text"
                            name="Memory"
                            value={formData?.Memory}
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Processor</label>
                          <input
                            type="text"
                            name="Processor"
                            value={formData?.Processor}
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {/** Pyment Detials Section */}
                  <div className="row mt-2">
                    <h5 className="fw-bold " style={{ color: "#2E2E48" }}>
                      Payment Details
                    </h5>
                    <hr></hr>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <lable className="form-label"> Payment Methods</lable>
                      <Select
                        options={paymentOption}
                        name="PaymentMethod"
                        value={paymentOption.find(
                          (o) => o.value == formData?.PaymentMethod
                        )}
                        onChange={(selectedOption, action) => (
                          handleSelect(selectedOption, action.name),
                          setFormData((prevData) => ({
                            ...prevData,
                            TransactionNo: "",
                          }))
                        )}
                      />
                    </div>
                    {formData?.PaymentMethod !== "" &&
                    formData?.PaymentMethod ? (
                      <div className="col-md-3">
                        <lable className="form-label">
                          {formData?.PaymentMethod === "rtgs"
                            ? "RTGS"
                            : formData?.PaymentMethod === "neft"
                            ? "NEFT"
                            : formData?.PaymentMethod === "chequeno"
                            ? "Cheque"
                            : ""}{" "}
                          No.
                        </lable>
                        <input
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          name="TransactionNo"
                          value={formData?.TransactionNo}
                        />
                      </div>
                    ) : null}
                    <div className="col-md-3 ">
                      <lable className="form-label">Payment Date</lable>
                      <CustomDatePicker
                        // handleChange={(e) => handleReqDate(e)}
                        handleChange={(e) => handleChange(e)}
                        value={formData?.PaymentDate}
                        name="PaymentDate"
                        className="form-control"
                        placeholderText="DD-MM-YYYY"
                      />
                    </div>
                  </div>
                  {/** Pyment Detials Section */}

                  <div className="row">
                    <div className="d-flex justify-content-end">
                      <div className="d-flex">
                        <div>
                          <button
                            type="button"
                            className="cancel-btn me-2"
                            onClick={() => navigate(`/add-asset`)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={loading ? true : false}
                            type="submit"
                            className="custom-btn"
                          >
                            {loading ? (
                              <FaSpinner class="sm-spinner" />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </form>
        </div>
      </>
    );
  }
};

export default EditAssetForm;
